import {useLocation, useNavigate} from "react-router-dom";
import { useEffect, useState } from "react";
import AdminHeader from "../../Components/AdminHeader/AdminHeader";
import AdminNav from "../../Components/AdminNav/AdminNav";
import 'react-quill/dist/quill.snow.css';
import { getBusinessVision } from "../../actions/BusinessPages";
import './style/BusinessStory.css'
import { IMAGE_URL } from "../../path";
import { updateBusinessVision } from "../../actions/BusinessPages";

function BusinessVision() {
    const ReactQuill = require('react-quill');
    const modules = {
        toolbar: [
          [{ 'header': [1, 2, 3, false] }],
          ['bold', 'italic', 'underline', 'strike'],
          [{ 'color': [] }, { 'background': [] }],
          [{ 'list': 'ordered' }, { 'list': 'bullet' }],
          [{ 'align': [] }],
          ['link', 'image'],
          ['clean'],
          // You can also add custom handlers or components here
        ],
      };

    const location = useLocation();
    const user = location.state?.user;

    const navigate = useNavigate();

    if (location === null || location.state === null || location.state.user === null) {
        navigate('/login');
    }

    const [section1Right, setSection1Right] = useState('');
    const [section2Right, setSection2Right] = useState('');

    const [imageFileDesktop1, setImageFileDesktop1] = useState<File | null>(null);
    const [previewUrlDesktop1, setPreviewUrlDesktop1] = useState<string>('');

    const [imageFileMobile1, setImageFileMobile1] = useState<File | null>(null);
    const [previewUrlMobile1, setPreviewUrlMobile1] = useState<string>('');

    const [imageFileDesktop2, setImageFileDesktop2] = useState<File | null>(null);
    const [previewUrlDesktop2, setPreviewUrlDesktop2] = useState<string>('');

    const [imageFileMobile2, setImageFileMobile2] = useState<File | null>(null);
    const [previewUrlMobile2, setPreviewUrlMobile2] = useState<string>('');

    const [businessStory, setBusinessStory] = useState<any[]>([]);

    // Add state for section titles
    const [section1Title, setSection1Title] = useState('');
    const [section2Title, setSection2Title] = useState('');
    const [section3Title, setSection3Title] = useState('');

        // Add state for full-width toggles
    const [image1FullWidth, setImage1FullWidth] = useState(false);
    const [image2FullWidth, setImage2FullWidth] = useState(false);

useEffect(() => {
    getBusinessVision()
      .then(response => {
        const data = response.data;
        setBusinessStory(data);

        // Add full width settings from data using is_full
        setImage1FullWidth(data[1]?.is_full || false);
        setImage2FullWidth(data[2]?.is_full || false);

        // Update titles
        setImage1Title(data[1]?.title || '');
        setSection2Title(data[0]?.title || '');
        setImage2Title(data[2]?.title || '');

        // Text section is data[0]
        setSection1Right(data[0]?.right_text || '');

        // Images
        setPreviewUrlDesktop1(IMAGE_URL + data[1]?.image);
        setPreviewUrlMobile1(IMAGE_URL + data[1]?.mobile_image);
        setPreviewUrlDesktop2(IMAGE_URL + data[2]?.image);
        setPreviewUrlMobile2(IMAGE_URL + data[2]?.mobile_image);
      })
      .catch(error => {
        // console.error("Failed to fetch business vision:", error);
      });
}, []);

const saveBusinessStory = async () => {
  try {
    const formData = new FormData();

    // Add titles
    formData.append("image1_title", image1Title);
    formData.append("main_heading", section2Title);
    formData.append("image2_title", image2Title);

    // Add is_full settings
    formData.append("image1_is_full", image1FullWidth.toString());
    formData.append("image2_is_full", image2FullWidth.toString());

    // Append text content
    formData.append("section1", section1Right);
    formData.append("section2R", section2Right);

    // Append images if selected
    if (imageFileDesktop1) formData.append("image1", imageFileDesktop1);
    if (imageFileMobile1) formData.append("mobile_image1", imageFileMobile1);
    if (imageFileDesktop2) formData.append("image2", imageFileDesktop2);
    if (imageFileMobile2) formData.append("mobile_image2", imageFileMobile2);

    const response = await updateBusinessVision(formData);

    if (response.status === 201) {
      alert("Business story saved successfully!");
    } else {
      console.error("Save failed:", response.data);
      alert("Failed to save. Please try again.");
    }
  } catch (error) {
    console.error("Error saving business vision:", error);
    alert("An error occurred while saving.");
  }
};


    // Image states
    const [mainImage, setMainImage] = useState<File | null>(null);
    const [mobileImage, setMobileImage] = useState<File | null>(null);
    const [mainImage2, setMainImage2] = useState<File | null>(null);
    const [mobileImage2, setMobileImage2] = useState<File | null>(null);

    const [image1Error, setImage1Error] = useState<string>("");
    const [image2Error, setImage2Error] = useState<string>("");

    const removeSelectedImage = (type: "desktop" | "mobile", id: 1 | 2) => {
        if (type === "desktop") {
            if (id == 1) {

                setImageFileDesktop1(null);
                setPreviewUrlDesktop1(`${IMAGE_URL}${businessStory[1].image}`);
            }
            else {
                setImageFileDesktop2(null);
                setPreviewUrlDesktop2(`${IMAGE_URL}${businessStory[3].image}`);
            }

        } else {
            if (id == 1) {
                setImageFileMobile1(null);
                setPreviewUrlMobile1(`${IMAGE_URL}${businessStory[1].mobile_image}`);
            } else {
                setImageFileMobile2(null);
                setPreviewUrlMobile2(`${IMAGE_URL}${businessStory[3].mobile_image}`);
            }

        }
      };

      const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>, type: "desktop" | "mobile", id: 1 | 2) => {
        const file = e.target.files?.[0];
        if (id == 1) {
            if (file) {
                if (!["image/jpeg", "image/jpg", "image/png"].includes(file.type)) {
                  setImage1Error("Please upload a valid image file (jpg, jpeg, or png).");
                  if (type === "desktop") setImageFileDesktop1(null);
                  else setImageFileMobile1(null);
                  return;
                }

                setImage1Error("");
                const objectUrl = URL.createObjectURL(file);

                if (type === "desktop") {
                  setImageFileDesktop1(file);
                  setPreviewUrlDesktop1(objectUrl);
                } else {
                  setImageFileMobile1(file);
                  setPreviewUrlMobile1(objectUrl);
                }
              }
        } else {
            if (file) {
                if (!["image/jpeg", "image/jpg", "image/png"].includes(file.type)) {
                  setImage2Error("Please upload a valid image file (jpg, jpeg, or png).");
                  if (type === "desktop") setImageFileDesktop2(null);
                  else setImageFileMobile2(null);
                  return;
                }

                setImage2Error("");
                const objectUrl = URL.createObjectURL(file);

                if (type === "desktop") {
                  setImageFileDesktop2(file);
                  setPreviewUrlDesktop2(objectUrl);
                } else {
                  setImageFileMobile2(file);
                  setPreviewUrlMobile2(objectUrl);
                }
              }
        }

      };

    const [image1Title, setImage1Title] = useState('');
    const [image2Title, setImage2Title] = useState('');

    const [isCollapsed, setIsCollapsed] = useState(true);


    return (
        <div>
            <AdminHeader isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} user={user} />
            <AdminNav collapsed={isCollapsed} setCollapsed={setIsCollapsed} user={user} />

            <div className={`main-admin-page ${isCollapsed ? 'collapsed' : 'expanded'}`}>
                <div className="main-admin-page-inner">
                    {/* First Image Section */}
                    <div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                            <input
                                type="text"
                                value={image1Title}
                                onChange={(e) => setImage1Title(e.target.value)}
                                placeholder="Image 1 Title"
                                style={{ width: '70%' }}
                            />
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <label style={{ marginRight: '10px' }}>Full Width:</label>
                                <input
                                    type="checkbox"
                                    checked={image1FullWidth}
                                    onChange={(e) => setImage1FullWidth(e.target.checked)}
                                />
                            </div>
                        </div>
                        <div className={`images-flex ${image1FullWidth ? 'full-width' : ''}`}>
                            {/* First Desktop/Mobile Image Upload Components */}
            <div>
                {/* Desktop Image Upload */}
            <div className="content-form-field">
              <label><strong>Desktop Image</strong></label><br />
              <input
                type="file"
                accept=".jpg,.jpeg,.png"
                onChange={(e) => handleImageChange(e, "desktop", 1)}
                style={{ margin: '10px 0' }}
              />
              {image1Error && <div style={{ color: 'red' }}>{image1Error}</div>}
              {previewUrlDesktop1 && (
                <div style={{ marginTop: '10px' }}>
                  <img
                    src={previewUrlDesktop1}
                    alt="Desktop Preview"
                    style={{ maxWidth: '100%', maxHeight: '300px', border: '1px solid #ccc' }}
                  />
                  <br />
                  <button type="button" onClick={() => removeSelectedImage("desktop", 1)} style={{ marginTop: '5px' }}>
                    Remove Desktop Image
                  </button>
                </div>
              )}
            </div>


            </div>
            <div>
                {/* Mobile Image Upload */}
            <div className="content-form-field">
              <label><strong>Mobile Image</strong></label><br />
              <input
                type="file"
                accept=".jpg,.jpeg,.png"
                onChange={(e) => handleImageChange(e, "mobile", 1)}
                style={{ margin: '10px 0' }}
              />
              {image1Error && <div style={{ color: 'red' }}>{image1Error}</div>}
              {previewUrlMobile1 && (
                <div style={{ marginTop: '10px' }}>
                  <img
                    src={previewUrlMobile1}
                    alt="Mobile Preview"
                    style={{ maxWidth: '100%', maxHeight: '300px', border: '1px solid #ccc' }}
                  />
                  <br />
                  <button type="button" onClick={() => removeSelectedImage("mobile", 1)} style={{ marginTop: '5px' }}>
                    Remove Mobile Image
                  </button>
                </div>
              )}
            </div>
            </div>

        </div>
                    </div>

                    {/* Text Section */}
                    <div style={{ marginTop: '30px' }}>
                        <input
                            type="text"
                            value={section2Title}
                            onChange={(e) => setSection2Title(e.target.value)}
                            placeholder="Section 2 Title (Optional)"
                            style={{ marginBottom: '10px', width: '100%' }}
                        />
                        <ReactQuill
                            id="section1Right"
                            value={section1Right}
                            onChange={setSection1Right}
                            modules={modules}
                            style={{ minHeight: '200px', marginBottom: '50px', height: '200px' }}
                        />
                    </div>

                    {/* Second Image Section */}
                    <div style={{ marginTop: '30px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                            <input
                                type="text"
                                value={image2Title}
                                onChange={(e) => setImage2Title(e.target.value)}
                                placeholder="Image 2 Title"
                                style={{ width: '70%' }}
                            />
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <label style={{ marginRight: '10px' }}>Full Width:</label>
                                <input
                                    type="checkbox"
                                    checked={image2FullWidth}
                                    onChange={(e) => setImage2FullWidth(e.target.checked)}
                                />
                            </div>
                        </div>
                        <div className={`images-flex ${image2FullWidth ? 'full-width' : ''}`}>
                            {/* Second Desktop/Mobile Image Upload Components */}
            <div>
                {/* Desktop Image Upload */}
            <div className="content-form-field">
              <label><strong>Desktop Image</strong></label><br />
              <input
                type="file"
                accept=".jpg,.jpeg,.png"
                onChange={(e) => handleImageChange(e, "desktop", 2)}
                style={{ margin: '10px 0' }}
              />
              {image2Error && <div style={{ color: 'red' }}>{image2Error}</div>}
              {previewUrlDesktop1 && (
                <div style={{ marginTop: '10px' }}>
                  <img
                    src={previewUrlDesktop2}
                    alt="Desktop Preview"
                    style={{ maxWidth: '100%', maxHeight: '300px', border: '1px solid #ccc' }}
                  />
                  <br />
                  <button type="button" onClick={() => removeSelectedImage("desktop", 2)} style={{ marginTop: '5px' }}>
                    Remove Desktop Image
                  </button>
                </div>
              )}
            </div>


            </div>
            <div>
                {/* Mobile Image Upload */}
            <div className="content-form-field">
              <label><strong>Mobile Image</strong></label><br />
              <input
                type="file"
                accept=".jpg,.jpeg,.png"
                onChange={(e) => handleImageChange(e, "mobile", 2)}
                style={{ margin: '10px 0' }}
              />
              {image2Error && <div style={{ color: 'red' }}>{image2Error}</div>}
              {previewUrlMobile2 && (
                <div style={{ marginTop: '10px' }}>
                  <img
                    src={previewUrlMobile2}
                    alt="Mobile Preview"
                    style={{ maxWidth: '100%', maxHeight: '300px', border: '1px solid #ccc' }}
                  />
                  <br />
                  <button type="button" onClick={() => removeSelectedImage("mobile", 2)} style={{ marginTop: '5px' }}>
                    Remove Mobile Image
                  </button>
                </div>
              )}
            </div>
            </div>

        </div>
                    </div>

                    {/* Save Button */}
                    <div style={{ marginTop: '30px' }}>
                        <button onClick={saveBusinessStory} style={{ padding: '10px 20px', fontSize: '16px' }}>
                            Save Changes
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BusinessVision;
